export default {"src":"/_next/static/media/vms.fa2b10d5.svg","height":24,"width":24};